module.exports = __webpack_public_path__ + "img/d- (8).c327a78f.png";